import { CellContext } from "@tanstack/react-table"

import { UITypes } from "types"

import { formatPhoneNumber } from "utils/formatPhoneNumber"

interface FormattedPhoneNumberProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const FormattedPhoneNumber = ({ cell: { row } }: FormattedPhoneNumberProps) => {
  if (!row.original.phone?.value) {
    return null
  }

  const formattedPhoneNumber = formatPhoneNumber(row.original.phone.value as string)

  return <>{formattedPhoneNumber}</>
}
